<template>
	<div class="seo-view container-fluid">
		<div class="row">
			<div class="col-8 main">

				<div v-for="item in objectdataSeoTextItems"
				     class="row">
					<erco-text-input class="col-12"
									 :data-infotextkey="`objectdata.${item.labelKey}`"
					                 :label="item.label"
					                 :text="getInputTextFor(item)"
					                 inputType="input"
					                 :keepUnfocused="true"
									 :forcePointerCursor="true"
									 :forceFocusOutline="isSidebarFocused(item.labelKey)"
									 :error="item.mandatory === 'true' && item.value === ''"
									 :tooltip="tooltipFor(item)"
									 :showMandatory="item.mandatory === 'true'"
									 :charlength="item.charlength"
					                 @click="openSidebarFor(item)">
					</erco-text-input>
				</div>

			</div>
			<div class="col-4 aside"></div>
		</div>
	</div>
</template>

<script>
	import Const from '@/constants';
	import InfoText from '@/helper/infoTextHelper';

	import ErcoTextInput from '@/components/molecules/ErcoTextInput';

	export default {
		name: 'ErcoObjectViewSeoOrganism',

		data() {
			return {
			};
		},

		props: {
			dataset: {
				type: Object,
				required: true,
			},
		},

		computed: {
			objectdataSeoTextItems() {
				return this.$store.getters.mappedObjectDataItems.seoItems;
			},
			objectdataSeoTextTranslations() {
				return this.$store.getters.mappedObjectDataItems.textItemsTranslations;
			},
			mandatoryMissing() {
				return this.$store.getters.getMissingMandatoryFields;
			},
		},

		methods: {
			openSidebarFor(item) {
				let type = '';
				let view = '';
				let outputData = {};
				let titleAdditional = '';

				if (item.enum) {
					type = 'enum';
					view = 'erco-sidebar-dropdown';
					outputData = [item];
				} else {
					type = 'text';
					view = 'erco-sidebar-tabbed-text-input';

					const tabs = Const.langs.map((lang) => {
						const text = (
							this.objectdataSeoTextTranslations[lang.key] &&
							this.objectdataSeoTextTranslations[lang.key].items[item.key] &&
							this.objectdataSeoTextTranslations[lang.key].items[item.key].value
						) || '';

						return {
							key: item.key,
							tabKey: lang.key,
							label: lang.text,
							text,
							toBeFetched: this.objectdataSeoTextTranslations[lang.key] === null,
						};
					});

					outputData = {
						tabChangeAction: 'getObjectDataTranslation',
						selectedTabKey: this.$store.state.objectsetup.current.sprache,
						tabs,
						charlength: (item.charlength && parseInt(item.charlength, 10)) || false,
					};

					if (outputData.charlength) {
						titleAdditional = `(max. ${outputData.charlength} Zeichen)`;
					}
				}

				const sidebarData = {
					visible: true,
					key: item.labelKey,
					view,
					fixed: true,
					outputData,
					context: {
						dispatchActionName: 'updateObjectDataItem',
						value: {
							siteId: this.$store.state.objectsites.objectdata.id,
							type,
						},
					},
					title: item.label,
					titleAdditional,
					info: this.tooltipFor(item),
				};

				this.$store.dispatch('updateSidebar', sidebarData);
			},

			tooltipFor(item) {
				const infoKey = `objectdata.${item.labelKey}`;
				const replacements = {};

				if (item.charlength) {
					replacements.maxChars = parseInt(item.charlength, 10);
				}

				return InfoText.for(infoKey, replacements)
					|| { variant: '', title: '', text: '' };
			},

			isSidebarFocused(key) {
				const sidebarStore = this.$store.state.sidebar;
				return sidebarStore.visible && sidebarStore.key === key;
			},

			getInputTextFor(item) {
				if (item.enum) {
					const matchingEnumItem = item.enum.find(currItem => currItem.value === item.value);

					if (matchingEnumItem) {
						return matchingEnumItem.label;
					}
				}

				return item.value;
			},
		},

		components: {
			ErcoTextInput,
		},
	};
</script>

<style lang="scss">
	.seo-view {
		.main {
			background-color: rgba(242, 242, 242, 1);
			border-right: 1px solid transparent;
			padding: 1.5rem 4rem;
		}

		.aside {
			background-color: rgba(242, 242, 242, 1);
			padding: 1.5rem 1rem;
		}
	}
</style>



// WEBPACK FOOTER //
// Seo.vue?8966de54